import { Directive, Input, SimpleChanges, ElementRef, OnChanges } from '@angular/core';

@Directive({
  selector: '[appLowercase]'
})
export class LowercaseDirective implements OnChanges {
  @Input() lowercase: boolean;

  constructor(private el: ElementRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.lowercase ? this.el.nativeElement.style.textTransform = 'lowercase' : this.el.nativeElement.style.textTransform = '';
  }
}
